<script setup lang="ts">
import { HomeButton } from '@/components/home'
import type { Exchange } from '@/types/shared/exchange'
import { useExchange } from '@/composables/game/exchange'
import { twMerge } from 'tailwind-merge'
import ExchangeMainIcon from '@/assets/images/exchange/exchange-main.webp'

const props = withDefaults(defineProps<{
  exchange: Exchange
  containerClass?: string
}>(), {
  containerClass: '',
})

const { countdownForExchangeEnd } = useExchange()
</script>

<template>
  <HomeButton
    variant="bottom"
    v-if="exchange"
    label="Exchange"
    :countdown="{ value: countdownForExchangeEnd, dangerThreshold: 3600 * 12 }"
    :button-class="twMerge('bg-[linear-gradient(180deg,#010101_0%,#B05902_100%)] p-0.5', containerClass)"
  >
    <img
      class="size-7 object-cover"
      :src="ExchangeMainIcon"
    >
  </HomeButton>
</template>
